export const style = {
  h2: {
    fontSize: `32px`,
    fontWeight: 300,
    color: `black`,
    margin: `0 0 -1px 0`,
    paddingBottom: `15px`,
    borderBottom: `rgba(0,0,0,0.07) 1px solid`,
    display: `inline-block`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Sitemap/style/headers.js